import http from "./HttpService";

const BASE_SERVICE_URL = "transactions-service";

export default {
    getTransactionHistory(request) {
        return new Promise((resolve, reject) => {
        http
            .get(BASE_SERVICE_URL + "/transaction/customer/history/" + request.body.currentPage, request.header)
            .then(response => {
                return resolve(response);
            })
            .catch((status, errors) => {
            reject(status, errors);
            });
        });
    }
};
